// ============================================================
// THE GM'S PROPOSED CLOSE-IN, ON THE GM'S MAP (plan design-gaps, Z2; the
// stealth page's ghost route): a dashed route from the watcher to where it
// would stop, in reach of the one it saw, a dashed ring there and the words.
// Drawn from the sighting bar's proposal, which only the director's screen
// holds - a player's map never draws it.
// ============================================================

import { memo } from 'react';
import type { Camera } from '../../engine/battlefield/projection';
import { SCENE_VIEW, project } from '../../engine/battlefield/projection';
import { tokenFoot, type Token } from '../../engine/battlefield/tokens';
import type { CloseIn } from '../../engine/stealth/closeIn';
import { groundRing } from './BeatMarks';
import styles from '../../styles/Display.module.css';

/** The close-in, named (useStealthSightings' `proposal`). */
type Proposal = Pick<CloseIn, 'moverId' | 'towardId' | 'at'> & { mover: string; toward: string };

export default memo(function CloseInGhost({
  proposal,
  tokens,
  camera,
}: {
  proposal: Proposal | null | undefined;
  tokens: Readonly<Record<string, Token>>;
  camera: Camera;
}) {
  const mover = proposal ? tokens[proposal.moverId] : undefined;
  if (!proposal || !mover) return null;
  const stop = { ...tokenFoot(mover), x: proposal.at.x, z: proposal.at.z };
  const [a, b] = [project(tokenFoot(mover), camera, SCENE_VIEW), project(stop, camera, SCENE_VIEW)];
  return (
    <g data-testid="close-in-ghost" className={styles.closeInGhost} pointerEvents="none">
      <line x1={a.x} y1={a.y} x2={b.x} y2={b.y} />
      <polygon points={groundRing(stop, mover.footprint, camera)} />
      <text x={b.x + 12} y={b.y - 8}>
        {`${proposal.mover} → beside ${proposal.toward}, in reach`}
      </text>
    </g>
  );
});
